export default {
    panelLoading: state => state.panelLoading,
    panelsListLoading: state => state.panelsListLoading,
    panelsList: state => state.panelsList,
}